import { connect } from "react-redux";
import Carousel from "../../../../components/Carousel";
import Image from '../../../../components/Image';
import Icon from '../../../../components/Icon';
import { medals } from "../../../../constants/medals";
import arrowForwardUpRight from '../../../../assets/icons/arrow_forward_up_right-semibold.svg'
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { useCallback, useMemo } from "react";
import {
  Container,
  Medal,
  Content,
  ExploreButton,
  Title
} from './styles'
import { CategoryDto } from "../../../../types/category";
import { Separator } from "../../../../components/StyledComponents";
import UnlockedCategoryMedal from "../../../components/UnlockedCategoryMedal";

const UnlockedCategoryBadged = ({ allCategories, group }) => {
  const { isMobile } = useWindowSize()

  const getLink = useCallback((category) => {
    return `/group/${group?.id}/p/c/${category?.id}`
  }, [group])

  const unlockedCategories = useMemo(() => {
    return allCategories
      ?.filter(item => item?.is_unlockable && item?.locked_ordinal)
      ?.filter(item => item?.last_posts && item?.last_posts?.length > 0)
      ?.filter(item => item?.user_access_data?.is_unlocked)
      ?.sort((a, b) => b.locked_ordinal - a.locked_ordinal);
  }, [allCategories]);

  if (!unlockedCategories || unlockedCategories?.length <= 0 || !group || !allCategories) {
    return <></>
  }



  return (
    <>
      <Title>Niveles desbloqueadas</Title>

      <Separator height={{ desktop: "16px", mobile: "16px" }} />

      <Carousel
        items={unlockedCategories}
        renderItem={(category: CategoryDto, index) => (
          <Container
            {...(category?.locked_ordinal ? { unlockOrder: category?.locked_ordinal } : {})}
            key={`unlocked-category-carousel-item-${index}`}
          >
            <UnlockedCategoryMedal category={category} width={isMobile ? "67px" : "69px"} height="auto" />
            <div style={{ height: 8 }} />
            <Content>
              <h4>Desbloqueaste un nuevo nivel:</h4>
              <div style={{ height: 8 }} />
              <h2>{category?.name}</h2>
            </Content>
            <div style={{ height: 16 }} />
            <ExploreButton href={getLink(category)} target="_blank">
              <span>Explorar ahora</span>
              <Icon icon={arrowForwardUpRight} size={isMobile ? "14px" : "24px"} color="white" />
            </ExploreButton>
          </Container>
        )}
        slidesToShow={3}
        scrollAmount={250}
        animationSpeed={400}
        showArrows={unlockedCategories?.length >= 4}
        style={isMobile ? {
          padding: "0px",
          scrollSnapType: "x mandatory",
          scrollPadding: "0px"
        } : {}}
      />
    </>
  )
}

const state = ({ categoryStore, groupStore }) => {
  const { data: allCategories } = categoryStore.allCategories;
  const { data: group } = groupStore.group;

  return {
    group,
    allCategories
  };
};

export default connect(state)(UnlockedCategoryBadged)